var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var DataType;
(function (DataType) {
    DataType["text"] = "text";
    DataType["decimal"] = "decimal";
    DataType["integer"] = "integer";
})(DataType || (DataType = {}));
export var Params;
(function (Params) {
    Params["sort"] = "sort";
    Params["filter"] = "filter";
    Params["hide"] = "hide";
})(Params || (Params = {}));
export var Comparison;
(function (Comparison) {
    Comparison["equal"] = "equal";
    Comparison["notEqual"] = "not-equal";
})(Comparison || (Comparison = {}));
export var CustomReportSource;
(function (CustomReportSource) {
    CustomReportSource["system"] = "system";
    CustomReportSource["user"] = "user";
})(CustomReportSource || (CustomReportSource = {}));
var Report = /** @class */ (function () {
    function Report() {
        this.additionalInfo = null;
        this.columnFilters = [];
        this.dataVersions = [];
        this.defaultSort = [];
        this.headers = [];
        this.hiddenColumns = [];
        this.historized = false;
        this.id = '';
        this.isCustom = false;
        this.name = '';
        this.reportTable = '';
        this.referentialColumns = [];
        this.removedHeaders = [];
        this.sort = [];
        this.source = undefined;
    }
    Report.createCopy = function (report) {
        var _a, _b, _c;
        var newReport = new Report();
        newReport.id = report.id;
        newReport.embedCode = report.embedCode;
        newReport.removedHeaders = report.removedHeaders;
        newReport.source = report.source;
        newReport.description = report.description;
        newReport.isCustom = (_a = report.isCustom) !== null && _a !== void 0 ? _a : false;
        newReport.additionalInfo = (_b = report.additionalInfo) !== null && _b !== void 0 ? _b : null;
        newReport.name = report.name;
        newReport.reportTable = report.reportTable;
        newReport.referentialColumns = __spreadArray([], report.referentialColumns, true);
        newReport.defaultSort = (_c = __spreadArray([], report.defaultSort, true)) !== null && _c !== void 0 ? _c : [];
        newReport.columnFilters = __spreadArray([], report.columnFilters, true);
        newReport.headers = __spreadArray([], report.headers, true);
        newReport.historized = report.historized;
        newReport.sort = __spreadArray([], report.sort, true);
        newReport.dataVersions = __spreadArray([], report.dataVersions, true);
        newReport.hiddenColumns = __spreadArray([], report.hiddenColumns, true);
        return newReport;
    };
    Report.createFromRawReport = function (report) {
        var _a, _b, _c;
        var newReport = new Report();
        newReport.embedCode = report.embedCode;
        newReport.id = report.id;
        newReport.isCustom = (_a = report.isCustom) !== null && _a !== void 0 ? _a : false;
        newReport.additionalInfo = (_b = report.additionalInfo) !== null && _b !== void 0 ? _b : null;
        newReport.name = report.name;
        newReport.reportTable = report.reportTable;
        newReport.description = report.description;
        newReport.historized = report.historized;
        newReport.source = report.source;
        newReport.referentialColumns = __spreadArray([], report.referentialColumns, true);
        newReport.defaultSort = (_c = __spreadArray([], report.defaultSort, true)) !== null && _c !== void 0 ? _c : [];
        newReport.columnFilters = __spreadArray([], report.columnFilters, true);
        newReport.headers = __spreadArray([], report.headers, true);
        newReport.sort = __spreadArray([], report.sort, true);
        newReport.dataVersions = __spreadArray([], report.dataVersions, true);
        newReport.hiddenColumns = __spreadArray([], report.hiddenColumns, true);
        newReport.removedHeaders = [];
        return newReport;
    };
    Object.defineProperty(Report.prototype, "reportSettings", {
        get: function () {
            return {
                columnFilters: this.columnFilters,
                hiddenColumns: this.hiddenColumns.map(function (column) { return column.id; }),
                sort: this.sort,
            };
        },
        enumerable: false,
        configurable: true
    });
    Report.prototype.addFilter = function (columnFilter) {
        this.columnFilters.push(columnFilter);
    };
    Report.prototype.addHiddenColumn = function (header) {
        this.hiddenColumns.push(header);
    };
    Report.prototype.addSort = function (sort) {
        var newSort = this.sort.filter(function (sorted) { return sorted.property !== sort.property; });
        newSort.push(sort);
        this.sort = newSort;
    };
    Report.prototype.getComparison = function (columnName) {
        if (this.columnFilters.length === 0) {
            return Comparison.notEqual;
        }
        var filtered = this.columnFilters.find(function (filter) { return filter.columnName === columnName; });
        if (filtered === undefined) {
            return Comparison.notEqual;
        }
        return filtered.comparison;
    };
    Report.prototype.getDefaultSort = function (headerId) {
        var result = this.defaultSort.find(function (sort) { return sort.property === headerId; });
        var emptySort = this.sort.length === 0;
        return result !== undefined && emptySort ? result.direction : null;
    };
    Report.prototype.getSort = function (headerId) {
        var result = this.sort.find(function (sort) { return sort.property === headerId; });
        return result !== undefined ? result.direction : null;
    };
    Report.prototype.isFiltered = function (headerId) {
        var result = this.columnFilters.find(function (filter) { return filter.columnName === headerId; });
        return result !== undefined;
    };
    Report.prototype.isFilteredValue = function (headerId, value) {
        var result = this.columnFilters.find(function (filter) { return filter.columnName === headerId && filter.value === value; });
        return result !== undefined;
    };
    Report.prototype.isHidden = function (headerId) {
        var result = this.hiddenColumns.find(function (column) { return column.id === headerId; });
        return result !== undefined;
    };
    Report.prototype.removeAllFilters = function (headerId) {
        var newColumnFilters = this.columnFilters.filter(function (filtered) { return headerId !== filtered.columnName; });
        this.columnFilters = newColumnFilters;
    };
    Report.prototype.isDeletable = function () {
        return this.isCustom && this.source === CustomReportSource.user;
    };
    Report.prototype.removeFilter = function (filter) {
        this.columnFilters = this.columnFilters.filter(function (filtered) { return filtered.columnName !== filter.columnName || filtered.value !== filter.value; });
    };
    Report.prototype.removeHiddenColumn = function (headerId) {
        var hidden = this.hiddenColumns.find(function (hidden) { return hidden.id === headerId; });
        this.hiddenColumns = this.hiddenColumns.filter(function (hidden) { return hidden.id !== headerId; });
        if (hidden !== undefined) {
            this.removedHeaders.push(hidden);
        }
    };
    Report.prototype.removeHiddenHeaders = function () {
        var _this = this;
        var hidden = new Set(this.hiddenColumns);
        var headers = this.headers;
        this.removedHeaders.forEach(function (removed) {
            if (!_this.headers.includes(removed) && !hidden.has(removed)) {
                headers.push(removed);
            }
        });
        this.headers = headers.filter(function (header) { return !hidden.has(header); }).sort(function (a, b) { return a.sequenceNumber - b.sequenceNumber; });
        this.removedHeaders = [];
    };
    Report.prototype.removeSort = function (headerId) {
        this.sort = this.sort.filter(function (sorted) { return sorted.property !== headerId; });
    };
    return Report;
}());
export { Report };
